import { useState, useEffect } from 'react';
export var useSmartChartTicks = function (ref) {
  var getTickValues = function (clientWidth) {
    return Math.ceil(clientWidth / 100);
  };
  var _a = useState(1),
    tickValues = _a[0],
    setTickValues = _a[1];
  var _b = useState(null),
    capValue = _b[0],
    setTicksCapValue = _b[1];
  useEffect(function () {
    var handleResize = function () {
      var chartWidth = ref.current ? ref.current.clientWidth : null;
      setTickValues(chartWidth ? getTickValues(chartWidth) : 1);
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  var noOfTicks = capValue ? Math.min(capValue, tickValues) : tickValues;
  return [noOfTicks, setTicksCapValue];
};